import axios from "axios";

export default {
    getPersonVacations: async (companyId, personId) => {
        const {data} = await axios.get(`/calendar/person_vacations/${companyId}/${personId}`)
        return data
    },
    saveCalendarEvent: async (id, payload) => {
        id = !id ? 0 : id
        const {data} = await axios.post(`/calendar/event/${id}`, payload)
        return data
    },
    deleteCalendarEvent: async (id) => {
        const {data} = await axios.delete(`/calendar/event/${id}`)
        return data
    },
    getCalendarPeriod: async (params) => {
        const {data} = await axios.get(`/calendar/period/`, {
            params: {
                date_from: params.date_from,
                date_until: params.date_until,
                account_id_list: params.account_id_list ? params.account_id_list : "",
                person_id_list: params.person_id_list ? params.person_id_list : "",
            }
        })
        return data
    }
}